import { ICONS } from './constants';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Alert header.
 *
 * The header is the main part of the alert, showing the icon, the heading message,
 * and the main alert message contents.
 *
 * @returns {ReactElement} div
 * @public
 */
export default function Header({ icon, type, children, heading }) {
  const Icon = icon || ICONS[type];

  return (
    <div className='alert-text-wrap'>
      <div className='alert-icon' aria-hidden='true'>
        <Icon />
      </div>
      <strong className='headline-primary' role='heading' aria-level='1'>{ heading }</strong> { children }
    </div>
  );
}

/**
 * Property types.
 *
 * @type {Object}
 * @private
 */
Header.propTypes = {
  /** The icon image */
  icon: PropTypes.node,
  /** The alert type we want to display  **/
  type: PropTypes.string,
  /** The alert message heading */
  heading: PropTypes.node,
  /** The alert message contents */
  children: PropTypes.node
};
